import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    errorText: {
      color: theme.palette.error.light,
      marginTop: 5,
      marginRight: 5,
      fontSize: 12
    },
    "& th ,td": {
      transition: "height 0.3s ease, width 0.3s ease"
    },
    tableBorder: {
      border: `solid 2px #007E92`
    },
    rowDisable: {
      background: "#fff !important",
      color: "#B4B4B4 !important",
      "& .MuiTypography-root, td,span": {
        color: "#B4B4B4 !important"
      },
      "& path": {
        fill: "#B4B4B4 !important"
      }
    },
    tableRoot: (props: { maxHeight?: string }) => ({
      overflowX: "auto",
      borderRadius: "0 5px 5px 5px",
      maxHeight: props?.maxHeight || "60vh",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTableCell-head": {
        background: "#DAF7FB"
      },
      "& .MuiCheckbox-root": {
        height: 32,
        width: 32,
        padding: 0,
        margin: 0,
        "& input": {
          height: 32,
          width: 32
        },
        boxShadow: "none !important"
      },
      "& .MuiFormHelperText-root.Mui-error": {
        marginLeft: 0,
        fontFamily: "ScgFont, sans-serif",
        fontWeight: 400,
        fontSize: "1.1rem",
        lineHeight: "16px",
        color: theme.palette.scgPrimary.main
      },
      marginBottom: 20,
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "8px",
          borderTop: "none",
          borderRight: `1px solid ${theme.palette.grey[300]}`
        }
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-root": {
          padding: "4px 8px",
          boxSizing: "border-box",
          borderRight: `1px solid ${theme.palette.grey[300]}`
        },
        "& .MuiTableCell-root:last-child": {
          borderRight: "none"
        }
      },
      "& .MuiTable-root": {
        position: "relative",
        overflowX: "auto",
        width: "100%",
        border: `none`,
        "& .MuiTableBody-root > tr > td": {
          borderBottom: "none"
        },
        "& .Mui-selected": {
          backgroundColor: "white !important"
        },
        "& .Mui-selected:nth-child(even) ": {
          backgroundColor: "#F2FAFB !important"
        }
      }
    }),
    tableLoading: {
      position: "absolute",
      zIndex: 10,
      height: "100%",
      width: "100%",
      backgroundColor: "black",
      opacity: 0.1,
      top: 0
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1
    },
    boxCheckBox: {
      "& .MuiCheckbox-root": {
        marginTop: "0.5rem"
      },
      marginTop: "1rem",
      display: "flex",
      flexDirection: "column"
    },
    tableHeader: {
      height: "78px"
    },
    tableHeaderLoading: {
      "&.MuiTableCell-root.MuiTableCell-head": {
        height: "4px",
        padding: "0px"
      }
    },
    delete: {
      fontSize: "12px",
      lineHeight: "22px",
      margin: "-3px -4px",
      fontFamily: "ScgFont, sans-serif",
      textAlign: "center",
      color: theme.palette.scgPrimary.main,
      fontWeight: 400
    },
    svgDatePicker: {
      marginRight: "0.8rem"
    },

    body3: {
      fontFamily: "SCG",
      fontSize: "1.4rem",
      fontWeight: 400,
      lineHeight: "22px",
      color: theme.palette.grey[900]
    },
    disabled: {
      pointerEvents: "none"
    },
    noBorderRight: {
      borderRight: "0 !important"
    },
    borderLeft: {
      borderLeft: `1px solid ${theme.palette.grey[300]}`
    },
    borderLeftMain: {
      borderLeft: `1px solid ${theme.palette.info.dark}`
    },
    borderBottom: {
      borderBottom: `1px solid ${theme.palette.grey[300]} !important`
    },
    borderRight: {
      borderRight: `1px solid ${theme.palette.grey[300]} !important`
    },
    root: {
      marginTop: "4rem"
    },
    childCell: {
      borderRight: "none !important"
    },
    noItemBody: {
      paddingTop: "24px",
      paddingBottom: "58px",
      paddingLeft: "16px",
      backgroundColor: "#FFFFFF",
      display: "flex"
    },
    smallBtn: {
      padding: "5px 28px",
      height: "32px"
    }
  }),
  {
    name: "AdvancedTable"
  }
);

export default useStyles;
